/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorFactbox from 'sites/allas/components/labrador/Factbox';

export const DynamicLabradorFactbox: typeof LabradorFactbox = (props) => {
    return <ErrorBoundary><LabradorFactbox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorFactboxProps = PropsFromComponent<typeof LabradorFactbox>;
